import * as React from 'react';
import { UitkBadge, UitkDealMemberBadge } from 'uitk-react-badge';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { UitkLayoutPosition } from 'uitk-react-layout-position';

// Support Types
import { HotelInventoryCardProps } from './types.d';
type OfferProps = Pick<HotelInventoryCardProps, 'offer'>;

interface SeparatorProps {
  modAvailabilityText?: string;
  modTagText?: string;
  discountBadge?: string;
}

const SeparatorBadge = ({ modText, badgeText }: { modText?: string | null; badgeText?: string }) => {
  if (modText) {
    return <UitkDealMemberBadge text={badgeText} />;
  }
  return <UitkBadge text={badgeText} />;
};

const Separator: React.FC<OfferProps> = ({ offer }: any) => {
  const separatorOffer = offer;
  const badgeText = separatorOffer.discountBadge?.text;
  const badgeClass = badgeText ? 'separatorLineWidth' : '';

  if (separatorOffer?.mod?.modAvailabilityText) {
    return (
      <>
        <div className={badgeClass}>
          <UitkSpacingHr blockMargin="one" />
        </div>
        <UitkLayoutPosition type="relative" position={{ top: 'minus-four' }} cloneElement>
          <div className="uitk-type-right uitk-type-200">
            <UitkDealMemberBadge text={separatorOffer?.mod?.modAvailabilityText} />
          </div>
        </UitkLayoutPosition>
      </>
    );
  }
  if (badgeText) {
    return (
      <>
        <div className={badgeClass}>
          <UitkSpacingHr blockMargin="one" />
        </div>
        <UitkLayoutPosition type="relative" position={{ top: 'minus-four' }} cloneElement>
          <div className="uitk-type-right">
            <SeparatorBadge modText={separatorOffer.mod?.modTagText} badgeText={badgeText} />
          </div>
        </UitkLayoutPosition>
      </>
    );
  }
  return (
    <UitkSpacing padding={{ blockend: 'six' }}>
      <div>
        <UitkSpacingHr blockMargin="one" />
      </div>
    </UitkSpacing>
  );
};

const SeparatorPropertySearch: React.FC<SeparatorProps> = (props) => {
  const { modAvailabilityText, discountBadge, modTagText } = props;
  const badgeClass = discountBadge ? 'separatorLineWidth' : '';

  if (modAvailabilityText) {
    return (
      <>
        <div className={badgeClass}>
          <UitkSpacingHr blockMargin="one" />
        </div>
        <UitkLayoutPosition type="relative" position={{ top: 'minus-four' }} cloneElement>
          <div className="uitk-type-right uitk-type-200">
            <UitkDealMemberBadge text={modAvailabilityText} />
          </div>
        </UitkLayoutPosition>
      </>
    );
  }
  if (discountBadge) {
    return (
      <>
        <div className={badgeClass}>
          <UitkSpacingHr blockMargin="one" />
        </div>
        <UitkLayoutPosition type="relative" position={{ top: 'minus-four' }} cloneElement>
          <div className="uitk-type-right">
            <SeparatorBadge modText={modTagText} badgeText={discountBadge} />
          </div>
        </UitkLayoutPosition>
      </>
    );
  }
  return (
    <UitkSpacing padding={{ blockend: 'six' }}>
      <div>
        <UitkSpacingHr blockMargin="one" />
      </div>
    </UitkSpacing>
  );
};

export { Separator, SeparatorPropertySearch, SeparatorProps };
